'use es6';

import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux';
import * as RequestStates from 'FormsCommonComponents/lib/RequestState';
import { getCurrentBusinessUnit, getIsShowingAllBusinessUnits } from 'FormsCommonComponents/utils/BusinessUnitsUtils';
import { REQUEST_FORM_CREATION, SUCCEED_CREATING_FORM, FAIL_CREATING_FORM, RESET_FORM_CREATION_STATE } from 'FormsUI/actions/formCreation/formCreationActions';
import { selectFormType, selectBusinessUnit } from 'FormsUI/actions/FormCreation';
import { FormCreationTypes } from 'FormsUI/constants/FormCreation';
const actionToState = {
  [REQUEST_FORM_CREATION]: RequestStates.REQUESTED,
  [SUCCEED_CREATING_FORM]: RequestStates.SUCCEEDED,
  [FAIL_CREATING_FORM]: RequestStates.FAILED,
  [RESET_FORM_CREATION_STATE]: RequestStates.NOT_REQUESTED
};
const DEFAULT_BUSINESS_UNIT = getIsShowingAllBusinessUnits() ? null : getCurrentBusinessUnit();
const selectedType = handleActions({
  [selectFormType]: (_, {
    payload: type
  }) => type
}, FormCreationTypes.REGULAR);
const selectedBusinessUnit = handleActions({
  [selectBusinessUnit]: (_, {
    payload: businessUnitId
  }) => businessUnitId
}, DEFAULT_BUSINESS_UNIT);
export function formCreationState(state = RequestStates.NOT_REQUESTED, {
  type
}) {
  // A map makes more sense than a switch here.
  if (Object.prototype.hasOwnProperty.call(actionToState, type)) {
    return actionToState[type];
  }
  return state;
}
export default combineReducers({
  requestState: formCreationState,
  selectedType,
  selectedBusinessUnit
});